import { Storage } from './StorageService';

export const isLogin = () => {
  const uuid = Storage.get('UUID');
  return !!uuid;
};
